import {
    PsHttpService,
    type PatSnapCommonResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { coreTelecomApiUrlPrefix } from '@telecom/shared/domain-config';
import type { WorkInProgressApi } from '../work-in-progress-api';
import type {
    WorkInProgressEmailNotificationResult,
    WorkInProgressTask,
} from '../../types/work-in-progress';

/**
 * 基于 Core Telecom API 的工作中任务接口实现。
 */
@injectable()
export class WorkInProgressApiImpl extends PsHttpService implements WorkInProgressApi {
    /**
     * HTTP 客户端基础配置。
     */
    get options() {
        return {
            baseURL: coreTelecomApiUrlPrefix,
        };
    }

    async getTasks(): Promise<WorkInProgressTask[]> {
        const response = await this.get<PatSnapCommonResponseData<WorkInProgressTask[]>>({
            url: '/ai/task/work-in-progress',
            method: 'GET',
        });
        return response.data as WorkInProgressTask[];
    }

    async requestEmailNotification(taskId: string): Promise<WorkInProgressEmailNotificationResult> {
        const encodedTaskId = encodeURIComponent(taskId);
        const response = await this.post<PatSnapCommonResponseData<WorkInProgressEmailNotificationResult>>({
            url: `/ai/task/${encodedTaskId}/email-notify`,
            method: 'POST',
        });
        return response.data as WorkInProgressEmailNotificationResult;
    }

    async markTaskExported(taskId: string): Promise<void> {
        const encodedTaskId = encodeURIComponent(taskId);
        await this.post<PatSnapCommonResponseData<void>>({
            url: `/ai/task/${encodedTaskId}/exported`,
            method: 'POST',
        });
    }
}
